import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import api from 'api';
import TokenTerms from './terms/TokenTerms';
import WalletTerms from './terms/WalletTerms';
import TradingTerms from './terms/TradingTerms';
import LockedTerms from './terms/LockedTerms';

class TermsModal extends Component {
  handleAccept = (terms, state) => {
    api
      .post(`onboarding/${terms}`)
      .then(res => {
        this.props.handleOnboarding(state);
        window.location = '/dashboard';
      })
      .catch(err => {
        console.error(err);
      });
  };

  render() {
    const { onboarding } = this.props;

    if (!onboarding) return null;

    const {
      token_tos_completed,
      wallet_address_completed,
      trading_tos_completed,
      locked_tokens_tos_completed
    } = onboarding;

    if (!token_tos_completed) {
      return (
        <TokenTerms
          onAccept={() =>
            this.handleAccept('token_terms', 'token_tos_completed')
          }
        />
      );
    } else if (!wallet_address_completed) {
      return (
        <WalletTerms
          onAccept={() =>
            this.handleAccept('wallet_terms', 'wallet_address_completed')
          }
        />
      );
    } else if (!trading_tos_completed) {
      return (
        <TradingTerms
          onAccept={() =>
            this.handleAccept('trading_terms', 'trading_tos_completed')
          }
        />
      );
    } else if (!locked_tokens_tos_completed) {
      return (
        <LockedTerms
          onAccept={() =>
            this.handleAccept(
              'locked_tokens_terms',
              'locked_tokens_tos_completed'
            )
          }
        />
      );
    }
  }
}

export default withRouter(TermsModal);
